import { Component } from '@angular/core';
//import {Router,RouteParams}  from '@angular/router';
import { Router, ActivatedRoute, Params  } from '@angular/router';
import { AuthService} from './service.auth';
import { PhotoService} from './service.photo';
import { CommonService} from './service.common';
// import { Credentials} from "./credentials";
// import { AuthToken} from "./authtoken";

@Component({
    selector: 'page-header',
    templateUrl: './html/pageHeader.html'
})
export class PageHeaderComponent{
//		private authToken: AuthToken;

  constructor(
    private authService: AuthService,
    private photoService: PhotoService,
    private commonService: CommonService,
	private route: ActivatedRoute,
    private router: Router
    ) {
//		this.authService.isAuthenticated();
		// setTimeout(() => {
		// 	this.authService.login(c).then(authRoles => this.authToken = authRoles);
		// }
		// //, 300
		// )
		
	}

	private showingPhotoId: number = null;
	private showingAlbumId: string = null;
	async ngOnInit() {

//		console.log('this.authService.isAuthenticated()');
//		console.log(await this.authService.isAuthenticated());

		if(! await this.authService.isAuthenticated()){
			document.location.assign('/login');
			//this.router.navigate(['/login']);
		}
		// if(localStorage.getItem("accountlogin") == "false"){
		//  	this.router.navigate(['/login']);
		// }
		
// 		this.showingPhotoId = this.route.snapshot.queryParams['pid'];
// 		this.showingAlbumId = this.route.snapshot.queryParams['aid'];

// 		if(this.showingPhotoId != null && this.showingAlbumId != null){
// 			await this.photoService.setAlbumsWithoutInitPhotos();
// 			await this.photoService.setCurrentAlbumByAlbumId(this.showingAlbumId)
// 			await this.commonService.getBackToReferer();
// 			//console.log(this.commonService.backToReferer);
// //			await this.getBackToReferer();
// //			.then(function(albumId){
// 				//this.setResultWithKeyword();
// 			console.log('this.showingPhotoId');
// 			console.log(this.showingPhotoId);

// 			this.commonService.myOpenPhotoSwipe(this.showingPhotoId);
// //			})
// 			;

// 		}
// 		else{
// 			this.photoService.setAlbums();
// 		}
 	}

	 public toggleHideFilter(): void{
        this.photoService.showFilter = ! this.photoService.showFilter;
    }


}


// WEBPACK FOOTER //
// ./src/app/pageHeader.ts